export default "__VITE_ASSET__D3kH3cUL__"